import { OffersV2ApiClient } from '@fourthwall/services/dist/OffersV2ApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useAssignBulkImagesMutation = createMutationHook(OffersV2ApiClient.assignBulkImages, {
  mutationKey: ['assignBulkImages'],
})
